var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.matters),function(matter,i){return _c('div',{key:i},[_c('div',[_vm._v(_vm._s(matter.caseName))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }